var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgEarth1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 236,
    viewBox: "0 0 213 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2533 235.06C159.919 235.06 212.341 182.639 212.341 117.975C212.341 53.3111 159.919 0.890625 95.2533 0.890625C30.5878 0.890625 -21.834 53.3111 -21.834 117.975C-21.834 182.639 30.5878 235.06 95.2533 235.06Z",
    fill: "url(#paint0_radial_804_86)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_804_86",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.848 227.455) rotate(-105.912) scale(258.014 314.071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.596806,
    stopColor: "#181616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866261,
    stopColor: "#103D66"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEarth1);
export default __webpack_public_path__ + "static/media/img-earth-1.86c5b53ddcfbb84ad4c592b830ece4b6.svg";
export { ForwardRef as ReactComponent };